export default __webpack_public_path__ + "static/media/MH.c47cb4a5.svg";